import { createFinderRoutes } from "./finder-route";
import { decodeFinderParams, replaceFinderParams, ownsFinderParameter } from "./finder-url-codec";

function currentLocation() {
  return new URL(window.location.href);
}

function pushLocation(value) {
  window.history.pushState({}, "", value);
}

function identity(value) {
  return value;
}

/** Composes events request URLs, public history URLs, and popstate restoration. */
export function createEventsHistory({
  requestParams = new URLSearchParams(),
  persistentParams = new URLSearchParams(),
  getLocation = currentLocation,
  pushUrl = pushLocation,
  decorateUrl = identity,
  undecorateUrl = identity,
  rootPath = "/events",
} = {}) {
  const routes = createFinderRoutes({ rootPath, resultsPath: "" });
  const context = decodeFinderParams(new URLSearchParams(requestParams));
  const persistent = decodeFinderParams(new URLSearchParams(persistentParams));

  function current() {
    return new URL(undecorateUrl(getLocation().toString()), getLocation());
  }

  function destination(value) {
    const url = new URL(value || routes.pathFor("results"), current());
    replaceFinderParams(url.searchParams, context);
    replaceFinderParams(url.searchParams, persistent);
    return url;
  }

  function commit(value) {
    const url = new URL(value);
    for (const key of [...url.searchParams.keys()]) {
      if (
        Object.keys(context).some((name) => ownsFinderParameter(name, key)) &&
        !Object.keys(persistent).some((name) => ownsFinderParameter(name, key))
      ) {
        url.searchParams.delete(key);
      }
    }
    pushUrl(decorateUrl(url.toString()));
  }

  function listen(restore) {
    function handlePopState() {
      restore(current());
    }
    window.addEventListener("popstate", handlePopState);
    function stop() {
      window.removeEventListener("popstate", handlePopState);
    }

    return stop;
  }
  return Object.freeze({ current, destination, commit, listen });
}
